export default function (prop) {
    var params = {};
    var search;

    /**
     * decodeURIComponent() runs over the whole query string at once, so a
     * malformed percent-escape anywhere in the url (e.g. `?source=%`) throws a
     * URIError. A broken url must never break the caller, so treat it as "no
     * parameters" and let each call site fall through to whatever it does
     * without one.
     */
    try {
        search = decodeURIComponent(window.location.href.slice(window.location.href.indexOf('?') + 1));
    } catch (e) {
        return null;
    }

    var definitions = search.split('&');

    definitions.forEach(function (val, key) {
        var parts = val.split('=', 2);
        params[parts[0]] = parts[1];
    });

    return (prop && prop in params) ? params[prop] : null;
}